import { ExportDataService } from '../services/file/export-data.service';
import { authGuard } from '../services/guards/auth.guard';
import { permissionGuard } from '../services/guards/permission.guard';
import { PermissionValue, ResourceValue } from '../services/permissions/permissions.types';
import { TitleTranslateResolver } from '../services/translate/title-translate.resolver';
import { ListingPageService } from '../shared/components/listing-page/listing-page.service';
import { QueryParamsHandlerService } from '../shared/components/listing-page/services/query-params-handler/query-params-handler.service';
import { ExportFileUrl } from '../shared/constants/export.constants';
import { EXPORT_URL_TOKEN } from '../shared/constants/tokens';
import { PortalPath, PortalRoute, RouteItem } from './app.types';
import { historyLogListingModelProvider } from './app.providers';
import { TranslateRegistry } from '../services/translate/translate.registry';
import { HistoryLogListingFiltersSourceService } from '../pages/equipment/history-log/components/history-log-listing-page/history-log-listing-filters-adapter.service';

export const historyLogRoutes: PortalRoute = {
  path: PortalPath.history,
  title: TitleTranslateResolver,
  canMatch: [authGuard, permissionGuard],
  data: {
    hasListingLayout: true,
    routeItem: new RouteItem({
      group: TranslateRegistry.get.MAIN_MENU.SECTION.EQUIPMENT,
      hasRight: {
        resourceValue: ResourceValue.HISTORY_LOG,
        targetPermissionValue: PermissionValue.VIEW
      },
      icon: 'history-log',
      path: PortalPath.history,
      title: TranslateRegistry.get.MAIN_MENU.TITLE.HISTORY_LOG
    }),
    titleTranslation: TranslateRegistry.get.MAIN_MENU.TITLE.HISTORY_LOG
  },
  loadComponent: () =>
    import('../pages/equipment/history-log/components/history-log-listing-page/history-log-listing-page.component').then(
      c => c.HistoryLogListingPageComponent
    ),
  providers: [
    HistoryLogListingFiltersSourceService,
    historyLogListingModelProvider,
    ListingPageService,
    QueryParamsHandlerService,
    ExportDataService,
    { provide: EXPORT_URL_TOKEN, useValue: ExportFileUrl.History }
  ]
};
